module.exports = __webpack_public_path__ + "static/media/branding-img5.4ed1cca9.jpg";